export default __webpack_public_path__ + "static/media/comprehensive-banner.7486d22d.png";